// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"6":"d8b77520","77":"b55078a5","182":"cfa4eeba","230":"1e71f2cf","318":"f3742876","359":"e6ff7af1","619":"cd1d7407","630":"7151bc0f","702":"7dcb343a","736":"25fdc416","810":"dccef38f","881":"d8bf2f96","884":"467c790d"}[chunkId] + ".chunk.js";
};